/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1515
 */

module.exports = {
  option: "Select_option__2wHq5"
}
